(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caliphe-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('caliphe-product-carousel')) {
    customElements.define('caliphe-product-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.chome__products');
        this.previous = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => {
          const position = Math.abs(this.track.scrollLeft);
          const end = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= end - 2;
        };
        const move = (direction) => {
          const card = this.track.querySelector('li');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({
            left: direction * rtl * (card.getBoundingClientRect().width + gap),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        this.setAttribute('data-ready', '');
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caliphe-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('caliphe-reviews')) {
    customElements.define('caliphe-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const track = this.querySelector('.creviews__track');
        const cards = Array.from(this.querySelectorAll('.creviews__card'));
        if (!track || !cards.length) return;
        const controls = this.querySelector('.creviews__controls');
        const current = this.querySelector('[data-current]');
        const previous = this.querySelector('[data-step="-1"]');
        const next = this.querySelector('[data-step="1"]');
        let active = Math.min(2, Math.floor(cards.length / 2));
        let frame = 0;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          let nearest = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const delta = Math.abs(rect.left + rect.width / 2 - center);
            if (delta < distance) { distance = delta; nearest = index; }
          });
          active = nearest;
          cards.forEach((card, index) => card.classList.toggle('is-active', index === active));
          if (current) current.textContent = String(active + 1);
          if (previous) previous.disabled = active === 0;
          if (next) next.disabled = active === cards.length - 1;
        };
        const go = (index, smooth = true) => {
          const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
          const rect = card.getBoundingClientRect();
          const trackRect = track.getBoundingClientRect();
          track.scrollBy({ left: rect.left + rect.width / 2 - trackRect.left - track.clientWidth / 2, behavior: smooth && !reduced.matches ? 'smooth' : 'instant' });
          if (!smooth || reduced.matches) update();
        };
        const scroll = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
        const click = event => {
          const button = event.target.closest('[data-step]');
          if (button && !button.disabled) go(active + Number(button.dataset.step));
        };
        const key = event => {
          if (event.target !== track) return;
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1);
            go(target);
          }
        };
        const select = event => {
          const index = cards.indexOf(event.target.closest('.creviews__card'));
          if (index >= 0) go(index, false);
        };
        const resize = new ResizeObserver(() => go(active, false));
        track.addEventListener('scroll', scroll, { passive: true });
        track.addEventListener('keydown', key);
        this.addEventListener('click', click);
        this.addEventListener('shopify:block:select', select);
        this.classList.add('is-ready');
        if (controls) controls.hidden = false;
        go(active, false);
        resize.observe(track);
        this.cleanup = () => {
          cancelAnimationFrame(frame);
          resize.disconnect();
          track.removeEventListener('scroll', scroll);
          track.removeEventListener('keydown', key);
          this.removeEventListener('click', click);
          this.removeEventListener('shopify:block:select', select);
        };
      }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
